import FacturaEmitirModal from './FacturaEmitirModal'

export default FacturaEmitirModal
